import type {TodoDb} from '@cp/model';
import type {TodoWithExpiration} from '../../hooks/todo/useTodos';

export default function filterTodosBySearch<T extends TodoDb | TodoWithExpiration>(
  todos: T[],
  searchQuery: string,
): T[] {
  if (!searchQuery.trim()) {
    return todos;
  }

  const query = searchQuery.toLowerCase().trim();

  return todos.filter((todo) => {
    const titleMatch = todo.title.toLowerCase().includes(query);
    const noteMatch = todo.note?.toLowerCase().includes(query) ?? false;
    const tagsMatch = todo.tags.some((tag) => tag.toLowerCase().includes(query));

    return titleMatch || noteMatch || tagsMatch;
  });
}
